import {
  Box,
  Button,
  Flex,
  Text,
  useDisclosure,
  Textarea,
  Input,
} from "@chakra-ui/react";
import React, { useEffect, useMemo, useState } from "react";
import {
  InputControl,
  SelectControl,
} from "../../components/form/formControls";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as Yup from "yup";
import { useCategories } from "../../categorys/settings/index";
import { DataSetting } from "../../utils/contants";
import { settingCall } from "../../api/settings";
import toast from "react-hot-toast";
import CheckinPlaceDialog from "../../components/dialog/delete";
import { Switch } from "@chakra-ui/react";
import { FormTimeKeeping } from "../../components/form/formTimeKeeping";
import PopupMasterPassword, {
  MASTER_PASSWORD_MODE,
} from "../../components/popup/popupMasterPassword";

// Thưởng giới thiệu: mỗi ô là 1 bản ghi cài đặt, để trống => BE dùng mặc định
// (services/referralEarning.service.js -> MILESTONES)
const REFERRAL_MILESTONE_FIELDS = [
  {
    title: "Mốc 1",
    fields: [
      {
        name: DataSetting.REFERRAL_MILESTONE_1_REQUIRED_DAY,
        label: "Số ngày đi làm cần đạt",
        placeholder: "Để trống: 7 ngày",
        isDayCount: true,
      },
      {
        name: DataSetting.REFERRAL_MILESTONE_1_AMOUNT,
        label: "Tiền thưởng nhân sự thường (VNĐ)",
        placeholder: "Để trống: 500000",
      },
      {
        name: DataSetting.REFERRAL_MILESTONE_1_HCNS_AMOUNT,
        label: "Tiền thưởng HCNS - nguồn công ty (VNĐ)",
        placeholder: "Để trống: 200000",
      },
    ],
  },
  {
    title: "Mốc 2",
    fields: [
      {
        name: DataSetting.REFERRAL_MILESTONE_2_REQUIRED_DAY,
        label: "Số ngày đi làm cần đạt",
        placeholder: "Để trống: 15 ngày",
        isDayCount: true,
      },
      {
        name: DataSetting.REFERRAL_MILESTONE_2_AMOUNT,
        label: "Tiền thưởng nhân sự thường (VNĐ)",
        placeholder: "Để trống: 500000",
      },
      {
        name: DataSetting.REFERRAL_MILESTONE_2_HCNS_AMOUNT,
        label: "Tiền thưởng HCNS - nguồn công ty (VNĐ)",
        placeholder: "Để trống: 200000",
      },
    ],
  },
];

const REFERRAL_MILESTONE_FIELD_LIST = REFERRAL_MILESTONE_FIELDS.flatMap(
  (milestone) => milestone.fields,
);

// Trống => null (dùng mặc định); số ngày phải nguyên >= 1, tiền phải >= 0
const parseReferralMilestoneValue = (field, raw) => {
  const text = raw === undefined || raw === null ? "" : String(raw).trim();
  if (text === "") return { value: null, isValid: true };

  const value = Number(text);
  const isValid = field.isDayCount
    ? Number.isInteger(value) && value >= 1
    : Number.isFinite(value) && value >= 0;

  return { value, isValid };
};

// Số tiền từng mức xăng xe: trống => BE dùng mặc định (services/fuelAllowance.service.js)
const FUEL_LEVEL_AMOUNT_FIELDS = [
  { level: 1, name: DataSetting.FUEL_LEVEL_1_AMOUNT, placeholder: "Để trống: 3000000" },
  { level: 2, name: DataSetting.FUEL_LEVEL_2_AMOUNT, placeholder: "Để trống: 5000000" },
  { level: 3, name: DataSetting.FUEL_LEVEL_3_AMOUNT, placeholder: "Để trống: 7000000" },
];

// const schema = Yup.object().shape({
//   checkinPlaceId: Yup.string().required("Vui lòng chọn địa chỉ chấm công"),
//   leaveRequestMoreShortTerm: Yup.string().required(
//     "Vui lòng chọn địa chỉ chấm công"
//   ),
//   leaveRequestMoreLongTerm: Yup.string().required(
//     "Vui lòng chọn địa chỉ chấm công"
//   ),
//   isSmtp: Yup.string().required("Vui lòng chọn địa chỉ chấm công"),
//   checkinRadius: Yup.string().required("Vui lòng nhập bán kính chấm công"),
//   maxFileSize: Yup.string().required("Vui lòng nhập size file"),
//   emailUser: Yup.string().required("Vui lòng nhập email"),
//   emailPassword: Yup.string().required("Vui lòng nhập mật khẩu email"),
// });

function SettingManagement() {
  const {
    isOpen: isOpenCheckinPlace,
    onOpen: onOpenCheckinPlace,
    onClose: onCloseCheckinPlace,
    // onToggle: onToggleCheckinPlace,
  } = useDisclosure();

  const {
    // reset,
    register,
    // handleSubmit,
    setValue,
    // refetch,
    getValues,
    watch,
    formState: { errors },
  } = useForm({
    resolver: yupResolver({}),
    defaultValues: {},
  });

  const [focusStates, setFocusStates] = useState({});
  const [shouldFetch, setShouldFetch] = useState(false);
  const [checkinPlaceId, setCheckinPlaceId] = useState("");
  const [registerCheckinPlaceId, setRegisterCheckinPlaceId] = useState("");
  const [checkedSwitch, setCheckedSwitch] = useState(false);
  const [checkedSwitchNotification, setCheckedSwitchNotification] =
    useState(false);
  const [checkedSwitchDeviceEnforce, setCheckedSwitchDeviceEnforce] =
    useState(false);
  const [deviceWhitelist, setDeviceWhitelist] = useState("");
  // Chấm công luồng mới: đăng ký thiết bị + địa điểm chấm công
  const [checkedSwitchCheckinV2, setCheckedSwitchCheckinV2] = useState(false);
  const [checkinV2ApplyDate, setCheckinV2ApplyDate] = useState("");
  // Nhắc chấm vào / chấm ra trước X phút (mặc định 5)
  const [checkinReminderMinutes, setCheckinReminderMinutes] = useState("5");
  // Xăng xe: bật => chỉ NV nhận xăng xe mới phải chấm ra; tắt => ai cũng phải chấm ra
  const [checkedSwitchFuel, setCheckedSwitchFuel] = useState(false);
  const [fuelApplyDate, setFuelApplyDate] = useState("");
  // Hạn gửi đơn xăng xe (ngày 1 -> ngày này), trống => mặc định ngày 10
  const [fuelDeadlineDay, setFuelDeadlineDay] = useState("");
  // Số tiền mức xăng xe 1/2/3 (VNĐ), trống => mặc định
  const [fuelLevelAmounts, setFuelLevelAmounts] = useState({ 1: "", 2: "", 3: "" });
  // Đơn chỉnh sửa công: bật (mặc định) => HCNS nhận thông báo + duyệt ngay, tắt => phải qua bước 1 quản lý
  const [checkedSwitchCorrectionHcnsDirect, setCheckedSwitchCorrectionHcnsDirect] =
    useState(true);
  // Đơn xin đi muộn: bật (mặc định) => HCNS nhận thông báo + duyệt ngay, tắt => phải qua bước 1 quản lý
  const [checkedSwitchLateHcnsDirect, setCheckedSwitchLateHcnsDirect] = useState(true);
  // Tính năng "Đơn xin đi muộn" (mặc định tắt)
  const [checkedSwitchLateRequest, setCheckedSwitchLateRequest] = useState(false);
  // Đơn xin đi muộn: áp quy tắc mới cho cả khối hỗ trợ KD (mặc định tắt => HTKD như cũ)
  const [checkedSwitchLateStrictSupport, setCheckedSwitchLateStrictSupport] = useState(false);
  // Đơn xăng xe: bật (mặc định) => HCNS nhận thông báo + duyệt ngay, tắt => phải qua bước 1 quản lý
  const [checkedSwitchFuelHcnsDirect, setCheckedSwitchFuelHcnsDirect] = useState(true);
  // Gửi thông báo đẩy (app + web): tắt khi chạy BE local trên DB clone từ live. Mặc định bật
  const [checkedSwitchPush, setCheckedSwitchPush] = useState(true);

  // Mật khẩu hỗ trợ đăng nhập - BE không trả về giá trị nên ngoài trang chỉ
  // hiện ***** và khoá ô nhập, muốn đổi hoặc xoá phải mở popup riêng để không
  // bấm nhầm nút Lưu chung của cả trang
  const [masterPasswordStatus, setMasterPasswordStatus] = useState(null);
  const [masterPasswordMode, setMasterPasswordMode] = useState(
    MASTER_PASSWORD_MODE.UPDATE,
  );
  const [isSavingMasterPassword, setIsSavingMasterPassword] = useState(false);

  const {
    isOpen: isOpenMasterPassword,
    onOpen: onOpenMasterPassword,
    onClose: onCloseMasterPassword,
  } = useDisclosure();

  useEffect(() => {
    const timer = setTimeout(() => {
      setShouldFetch(true);
    }, 1200);

    return () => clearTimeout(timer);
  }, []);

  useEffect(() => {
    const fetchDataCheckinPlaceId = async () => {
      try {
        const placeCheckin = await settingCall.get(
          DataSetting.PLACE_CHECKIN_ID,
        );

        if (placeCheckin?.items?.value) {
          setValue("checkinPlaceId", placeCheckin?.items?.value);
          setCheckinPlaceId(placeCheckin?.items?.value);
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    const fetchDataRegisterCheckinPlaceId = async () => {
      try {
        const placeRegisterCheckin = await settingCall.get(
          DataSetting.PLACE_REGISTER_CHECKIN_ID,
        );

        if (placeRegisterCheckin?.items?.value) {
          setValue(
            "registerCheckinPlaceId",
            placeRegisterCheckin?.items?.value,
          );
          setRegisterCheckinPlaceId(placeRegisterCheckin?.items?.value);
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    const fetchDataLatestEmployeeId = async () => {
      try {
        const placeCheckin = await settingCall.get(
          DataSetting.latest_employee_id,
        );

        if (placeCheckin?.items?.value) {
          setValue("latestEmployeeId", placeCheckin?.items?.value);
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    const fetchDataDateLatestEmployee = async () => {
      try {
        const placeCheckin = await settingCall.get(
          DataSetting.DATE_PROFILE_COMPLETE_EMPLOYEE,
        );

        if (placeCheckin?.items?.value) {
          setValue("dateLatestEmployee", placeCheckin?.items?.value);
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    const fetchDataleaveRequestMoreShortTerm = async () => {
      try {
        const placeCheckin = await settingCall.get(
          DataSetting.LEAVERE_QUEST_MORE_SHORT_TERM,
        );

        if (placeCheckin?.items?.value) {
          setValue("leaveRequestMoreShortTerm", placeCheckin?.items?.value);
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    const fetchDataLeaveRequestMoreLongTerm = async () => {
      try {
        const placeCheckin = await settingCall.get(
          DataSetting.LEAVERE_QUEST_MORE_LONG_TERM,
        );

        if (placeCheckin?.items?.value) {
          setValue("leaveRequestMoreLongTerm", placeCheckin?.items?.value);
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    const fetchDataIsSmtp = async () => {
      try {
        const placeCheckin = await settingCall.get(DataSetting.ISSMTP);

        if (placeCheckin?.items?.value) {
          setValue("isSmtp", placeCheckin?.items?.value);
          setCheckedSwitch(Boolean(placeCheckin?.items?.value));
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    const fetchDataCheckinRadius = async () => {
      try {
        const checkinRadius = await settingCall.get(DataSetting.CHECKIN_RADIUS);

        if (checkinRadius?.items?.value) {
          setValue("checkinRadius", checkinRadius?.items?.value);
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    const fetchDataMaxFileSize = async () => {
      try {
        const maxFileSize = await settingCall.get(DataSetting.MAX_FILE_SIZE);

        if (maxFileSize?.items?.value) {
          const size = Number(maxFileSize?.items?.value) / (1024 * 1024);
          const roundedSize = Number.isInteger(size) ? size : size.toFixed(2);
          setValue("maxFileSize", roundedSize);
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    const fetchDataHalfDayLeaveAfternoonStart = async () => {
      try {
        const halfDayLeaveAfternoonStart = await settingCall.get(
          DataSetting.HALF_DAY_LEAVE_AFTERNOON_START,
        );

        if (halfDayLeaveAfternoonStart?.items?.value) {
          const time = halfDayLeaveAfternoonStart.items.value;
          setValue("halfDayLeaveAfternoonStart", time);
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    const fetchDataBlockCheckin = async () => {
      try {
        const blockCheckinTime = await settingCall.get(
          DataSetting.BLOCK_CHECKIN,
        );

        if (blockCheckinTime?.items?.value) {
          const time = blockCheckinTime.items.value;
          setValue("blockCheckinTime", time);
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    // Hạn gửi đơn chấm công ngoài (chưa cài => hiện 10:00 như BE mặc định)
    const fetchDataRegisterCheckinDeadline = async () => {
      try {
        const registerCheckinDeadline = await settingCall.get(
          DataSetting.REGISTER_CHECKIN_DEADLINE,
        );
        setValue(
          "registerCheckinDeadline",
          registerCheckinDeadline?.items?.value || "10:00",
        );
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    const fetchDataBlockCheckinTimeStart = async () => {
      try {
        const blockCheckinTimeStart = await settingCall.get(
          DataSetting.BLOCK_CHECK_IN_TIME,
        );

        if (blockCheckinTimeStart?.items?.value) {
          const time = blockCheckinTimeStart.items.value;
          setValue("blockCheckinTimeStart", time);
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    const fetchDataEmailUser = async () => {
      try {
        const emailUser = await settingCall.get(DataSetting.EMAIL_USER);

        if (emailUser?.items?.value) {
          setValue("emailUser", emailUser?.items?.value);
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    const fetchDataEmailPassword = async () => {
      try {
        const emailPassword = await settingCall.get(DataSetting.EMAIL_PASSWORD);

        if (emailPassword?.items?.value) {
          setValue("emailPassword", emailPassword?.items?.value);
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    const fetchAppVersion = async () => {
      try {
        const appData = await settingCall.getAppUpdate();

        if (appData) {
          if (appData?.versionName)
            setValue("versionName", appData?.versionName);
          if (appData?.urlAndroid) setValue("urlAndroid", appData?.urlAndroid);
          if (appData?.urlIos) setValue("urlIos", appData?.urlIos);
          if (appData?.isForce) {
            setValue("isForce", appData?.isForce);
            setCheckedSwitchNotification(Boolean(appData?.isForce));
          }
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    const fetchDateDeleteTransactionHistory = async () => {
      try {
        const DATE_DELETE_TRANSACTION_HISTORY = await settingCall.get(
          DataSetting.DATE_DELETE_TRANSACTION_HISTORY,
        );

        if (DATE_DELETE_TRANSACTION_HISTORY?.items?.value) {
          setValue(
            "DATE_DELETE_TRANSACTION_HISTORY",
            DATE_DELETE_TRANSACTION_HISTORY?.items?.value,
          );
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    const fetchDeviceEnforceLogin = async () => {
      try {
        const s = await settingCall.get(DataSetting.DEVICE_ENFORCE_LOGIN);
        const val = Boolean(s?.items?.value); // backend có thể trả true/false hoặc 0/1
        setValue("deviceEnforceLogin", val);
        setCheckedSwitchDeviceEnforce(val);
      } catch (error) {
        console.error("Error fetching device enforce login:", error);
      }
    };

    const fetchDeviceWhitelistBypass = async () => {
      try {
        const s = await settingCall.get(DataSetting.DEVICE_WHITELIST_BYPASS);
        const val = s?.items?.value ? String(s.items.value) : "";
        setValue("deviceWhitelistBypass", val);
        setDeviceWhitelist(val);
      } catch (error) {
        console.error("Error fetching device whitelist bypass:", error);
      }
    };

    const fetchCheckinV2 = async () => {
      try {
        const [
          enabled,
          applyDate,
          reminderMinutes,
          fuelEnabled,
          fuelDate,
          fuelDeadline,
          correctionHcnsDirect,
          pushEnabled,
          fuelHcnsDirect,
          lateHcnsDirect,
          lateRequest,
          lateStrictSupport,
        ] = await Promise.all([
          settingCall.get(DataSetting.CHECKIN_V2_ENABLED),
          settingCall.get(DataSetting.CHECKIN_V2_APPLY_DATE),
          settingCall.get(DataSetting.CHECKIN_REMINDER_MINUTES),
          settingCall.get(DataSetting.FUEL_ALLOWANCE_ENABLED),
          settingCall.get(DataSetting.FUEL_ALLOWANCE_APPLY_DATE),
          settingCall.get(DataSetting.FUEL_REQUEST_DEADLINE_DAY),
          settingCall.get(DataSetting.CHECKIN_CORRECTION_HCNS_DIRECT),
          settingCall.get(DataSetting.PUSH_NOTIFICATION_ENABLED),
          settingCall.get(DataSetting.FUEL_REQUEST_HCNS_DIRECT),
          settingCall.get(DataSetting.LATE_CHECKIN_HCNS_DIRECT),
          settingCall.get(DataSetting.LATE_CHECKIN_REQUEST_ENABLED),
          settingCall.get(DataSetting.LATE_CHECKIN_STRICT_SUPPORT),
        ]);
        const fuelAmounts = await Promise.all(
          FUEL_LEVEL_AMOUNT_FIELDS.map((f) => settingCall.get(f.name)),
        );
        setFuelLevelAmounts(
          Object.fromEntries(
            FUEL_LEVEL_AMOUNT_FIELDS.map((f, i) => {
              const v = fuelAmounts[i]?.items?.value;
              return [f.level, v !== undefined && v !== null ? String(v) : ""];
            }),
          ),
        );
        // Chưa có bản ghi => bật (giống BE)
        const isOn = (v) => !(v === false || v === "false");
        setCheckedSwitchCorrectionHcnsDirect(isOn(correctionHcnsDirect?.items?.value));
        setCheckedSwitchPush(isOn(pushEnabled?.items?.value));
        setCheckedSwitchFuelHcnsDirect(isOn(fuelHcnsDirect?.items?.value));
        setCheckedSwitchLateHcnsDirect(isOn(lateHcnsDirect?.items?.value));
        // Đơn xin đi muộn: chưa có bản ghi => tắt (giống BE)
        const lateRequestValue = lateRequest?.items?.value;
        setCheckedSwitchLateRequest(lateRequestValue === true || lateRequestValue === "true");
        const lateStrictSupportValue = lateStrictSupport?.items?.value;
        setCheckedSwitchLateStrictSupport(
          lateStrictSupportValue === true || lateStrictSupportValue === "true",
        );
        setFuelDeadlineDay(
          fuelDeadline?.items?.value !== undefined &&
            fuelDeadline?.items?.value !== null
            ? String(fuelDeadline.items.value)
            : "",
        );
        setCheckedSwitchFuel(
          fuelEnabled?.items?.value === true ||
            fuelEnabled?.items?.value === "true",
        );
        setFuelApplyDate(
          fuelDate?.items?.value ? String(fuelDate.items.value) : "",
        );
        if (
          reminderMinutes?.items?.value !== undefined &&
          reminderMinutes?.items?.value !== null
        ) {
          setCheckinReminderMinutes(String(reminderMinutes.items.value));
        }
        setCheckedSwitchCheckinV2(
          enabled?.items?.value === true || enabled?.items?.value === "true",
        );
        setCheckinV2ApplyDate(
          applyDate?.items?.value ? String(applyDate.items.value) : "",
        );
      } catch (error) {
        console.error("Error fetching checkin v2 setting:", error);
      }
    };

    fetchDataCheckinPlaceId();
    fetchDataRegisterCheckinPlaceId();
    fetchDataleaveRequestMoreShortTerm();
    fetchDataLatestEmployeeId();
    fetchDataDateLatestEmployee();
    fetchDataLeaveRequestMoreLongTerm();
    fetchDataIsSmtp();
    fetchDataCheckinRadius();
    fetchDataMaxFileSize();
    fetchDataEmailUser();
    fetchDataEmailPassword();
    fetchDataHalfDayLeaveAfternoonStart();
    fetchDataBlockCheckinTimeStart();
    fetchDataBlockCheckin();
    fetchDataRegisterCheckinDeadline();
    fetchAppVersion();
    fetchDateDeleteTransactionHistory();
    fetchDeviceEnforceLogin();
    const fetchReferralMilestones = async () => {
      try {
        const responses = await Promise.all(
          REFERRAL_MILESTONE_FIELD_LIST.map((field) =>
            settingCall.get(field.name),
          ),
        );

        responses.forEach((response, index) => {
          const value = response?.items?.value;
          if (value !== undefined && value !== null && value !== "") {
            setValue(REFERRAL_MILESTONE_FIELD_LIST[index].name, String(value));
          }
        });
      } catch (error) {
        console.error("Error fetching referral milestone setting:", error);
      }
    };

    fetchDeviceWhitelistBypass();
    fetchCheckinV2();
    fetchReferralMilestones();
  }, []);

  const { constantData } = useCategories(null, null, 1, shouldFetch);

  const formatEntries = (entries) =>
    Object.entries(entries || {}).map(([key, value]) => ({
      value: key,
      label: value,
    }));

  const handleBlur = (field) => {
    setFocusStates((prev) => ({ ...prev, [field]: false }));
  };

  const handleFocus = (field) => {
    setFocusStates((prev) => ({ ...prev, [field]: true }));
  };

  const checkinPlaces = useMemo(
    () => formatEntries(constantData?.checkinPlace),
    [constantData?.checkinPlace],
  );

  const onCloseCheckinPlaceData = () => {
    onOpenCheckinPlace();
  };

  const onchangeCheckinPlace = (option) => {
    // setValue("checkinPlaceId", option);
    const currentValue = getValues("checkinPlaceId");
    if (currentValue === option) {
      setValue("checkinPlaceId", "");
      setCheckinPlaceId("");
    } else {
      setValue("checkinPlaceId", option);
      setCheckinPlaceId(option);
    }
  };

  const onchangeRegisterCheckinPlace = (option) => {
    const currentValue = getValues("registerCheckinPlaceId");
    if (currentValue === option) {
      setValue("registerCheckinPlaceId", "");
      setRegisterCheckinPlaceId("");
    } else {
      setValue("registerCheckinPlaceId", option);
      setRegisterCheckinPlaceId(option);
    }
  };

  const fetchMasterPasswordStatus = async () => {
    try {
      const response = await settingCall.getMasterPassword();
      setMasterPasswordStatus(response ?? null);
    } catch (error) {
      console.error("Error fetching master password status:", error);
    }
  };

  useEffect(() => {
    fetchMasterPasswordStatus();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const openMasterPasswordPopup = (mode) => {
    setMasterPasswordMode(mode);
    onOpenMasterPassword();
  };

  // Đổi / xoá mật khẩu hỗ trợ đi API riêng, không đi chung nút Lưu của cả trang
  const submitHandlerMasterPassword = async (data) => {
    const isClear = masterPasswordMode === MASTER_PASSWORD_MODE.CLEAR;

    const toastUpdate = toast.loading(
      isClear ? "Đang xoá mật khẩu hỗ trợ..." : "Đang cập nhật mật khẩu hỗ trợ...",
    );
    setIsSavingMasterPassword(true);

    try {
      await settingCall.updateMasterPassword({
        currentPassword: data?.currentPassword || "",
        newPassword: isClear ? "" : data?.newPassword || "",
        confirmNewPassword: isClear ? "" : data?.confirmNewPassword || "",
      });

      await fetchMasterPasswordStatus();
      onCloseMasterPassword();
      toast.success(isClear ? "Đã xoá mật khẩu hỗ trợ" : "Cập nhật thành công");
    } catch (error) {
      console.error("Error updating master password:", error);
    }

    setIsSavingMasterPassword(false);
    toast.dismiss(toastUpdate);
  };

  const submitHandlerCheckinPlace = async () => {
    const referralMilestoneValues = REFERRAL_MILESTONE_FIELD_LIST.map(
      (field) => ({
        field,
        ...parseReferralMilestoneValue(field, getValues(field.name)),
      }),
    );

    const invalidReferralMilestone = referralMilestoneValues.find(
      (item) => !item.isValid,
    );

    if (invalidReferralMilestone) {
      toast.error(
        invalidReferralMilestone.field.isDayCount
          ? "Thưởng giới thiệu: số ngày đi làm cần đạt phải là số nguyên từ 1 trở lên"
          : "Thưởng giới thiệu: tiền thưởng phải là số từ 0 trở lên",
      );
      return;
    }

    // Số tiền mức xăng xe: trống hoặc số nguyên > 0
    const fuelAmountValues = FUEL_LEVEL_AMOUNT_FIELDS.map((f) => {
      const text = String(fuelLevelAmounts[f.level] ?? "").trim();
      const value = Number(text);
      return {
        field: f,
        value: text === "" ? null : value,
        isValid: text === "" || (Number.isInteger(value) && value > 0),
      };
    });
    if (fuelAmountValues.some((item) => !item.isValid)) {
      toast.error("Xăng xe: số tiền mỗi mức phải là số nguyên lớn hơn 0");
      return;
    }

    const toastCreate = toast.loading("Đang sửa cài đặt mặc định...");
    try {
      const checkinPlaceId = getValues("checkinPlaceId");
      const registerCheckinPlaceId = getValues("registerCheckinPlaceId");
      const leaveRequestMoreShortTerm = getValues("leaveRequestMoreShortTerm");
      const latestEmployeeId = getValues("latestEmployeeId");
      const dateLatestEmployee = getValues("dateLatestEmployee");
      const leaveRequestMoreLongTerm = getValues("leaveRequestMoreLongTerm");
      const isSmtp = getValues("isSmtp");
      const checkinRadius = getValues("checkinRadius");
      const maxFileSize = getValues("maxFileSize");
      const halfDayLeaveAfternoonStart = getValues(
        "halfDayLeaveAfternoonStart",
      );
      const blockCheckinTime = getValues("blockCheckinTime");
      const blockCheckinTimeStart = getValues("blockCheckinTimeStart");
      const registerCheckinDeadline = getValues("registerCheckinDeadline");
      const emailUser = getValues("emailUser");
      const emailPassword = getValues("emailPassword");
      const DATE_DELETE_TRANSACTION_HISTORY = getValues(
        "DATE_DELETE_TRANSACTION_HISTORY",
      );

      //
      const versionName = getValues("versionName");
      const urlAndroid = getValues("urlAndroid");
      const urlIos = getValues("urlIos");
      const isForce = getValues("isForce");
      const optionsUpdateAppVersion = {
        versionName,
        urlAndroid,
        urlIos,
        isForce,
      };
      //

      const deviceEnforceLogin = getValues("deviceEnforceLogin");
      const deviceWhitelistBypass = getValues("deviceWhitelistBypass");

      const dataFilter = [
        {
          websiteCode: DataSetting.MSH_GROUP,
          name: DataSetting.PLACE_CHECKIN_ID,
          value: checkinPlaceId || null,
        },
        {
          websiteCode: DataSetting.MSH_GROUP,
          name: DataSetting.PLACE_REGISTER_CHECKIN_ID,
          value: registerCheckinPlaceId || null,
        },
        {
          websiteCode: DataSetting.MSH_GROUP,
          name: DataSetting.LEAVERE_QUEST_MORE_SHORT_TERM,
          value: leaveRequestMoreShortTerm || null,
        },
        {
          websiteCode: DataSetting.MSH_GROUP,
          name: DataSetting.latest_employee_id,
          value: latestEmployeeId ? Number(latestEmployeeId) : null,
        },
        {
          websiteCode: DataSetting.MSH_GROUP,
          name: DataSetting.DATE_PROFILE_COMPLETE_EMPLOYEE,
          value: dateLatestEmployee ? Number(dateLatestEmployee) : null,
        },
        {
          websiteCode: DataSetting.MSH_GROUP,
          name: DataSetting.LEAVERE_QUEST_MORE_LONG_TERM,
          value: leaveRequestMoreLongTerm || null,
        },
        {
          websiteCode: DataSetting.MSH_GROUP,
          name: DataSetting.ISSMTP,
          value: isSmtp || (isSmtp === false ? isSmtp : null),
        },
        {
          websiteCode: DataSetting.MSH_GROUP,
          name: DataSetting.CHECKIN_RADIUS,
          value: checkinRadius || null,
        },
        {
          websiteCode: DataSetting.MSH_GROUP,
          name: DataSetting.MAX_FILE_SIZE,
          value: maxFileSize ? Number(maxFileSize) * (1024 * 1024) : null,
        },
        {
          websiteCode: DataSetting.MSH_GROUP,
          name: DataSetting.HALF_DAY_LEAVE_AFTERNOON_START,
          value: halfDayLeaveAfternoonStart ? halfDayLeaveAfternoonStart : null,
        },
        {
          websiteCode: DataSetting.MSH_GROUP,
          name: DataSetting.BLOCK_CHECK_IN_TIME,
          value: blockCheckinTimeStart ? blockCheckinTimeStart : null,
        },
        {
          websiteCode: DataSetting.MSH_GROUP,
          name: DataSetting.BLOCK_CHECKIN,
          value: blockCheckinTime ? blockCheckinTime : null,
        },
        {
          websiteCode: DataSetting.MSH_GROUP,
          name: DataSetting.REGISTER_CHECKIN_DEADLINE,
          // Trống => null (BE dùng mặc định 10:00)
          value: registerCheckinDeadline ? registerCheckinDeadline : null,
        },
        {
          websiteCode: DataSetting.MSH_GROUP,
          name: DataSetting.EMAIL_USER,
          value: emailUser || null,
        },
        {
          websiteCode: DataSetting.MSH_GROUP,
          name: DataSetting.EMAIL_PASSWORD,
          value: emailPassword || null,
        },
        {
          websiteCode: DataSetting.MSH_GROUP,
          name: DataSetting.DATE_DELETE_TRANSACTION_HISTORY,
          value: DATE_DELETE_TRANSACTION_HISTORY
            ? Number(DATE_DELETE_TRANSACTION_HISTORY)
            : null,
        },
        {
          websiteCode: DataSetting.MSH_GROUP,
          name: DataSetting.DEVICE_ENFORCE_LOGIN,
          value: deviceEnforceLogin ?? false,
        },
        {
          websiteCode: DataSetting.MSH_GROUP,
          name: DataSetting.DEVICE_WHITELIST_BYPASS,
          value: deviceWhitelistBypass
            ? String(deviceWhitelistBypass).trim()
            : null,
        },
        {
          websiteCode: DataSetting.MSH_GROUP,
          name: DataSetting.CHECKIN_V2_ENABLED,
          value: checkedSwitchCheckinV2,
        },
        {
          websiteCode: DataSetting.MSH_GROUP,
          name: DataSetting.CHECKIN_V2_APPLY_DATE,
          value: checkinV2ApplyDate || null,
        },
        {
          websiteCode: DataSetting.MSH_GROUP,
          name: DataSetting.CHECKIN_REMINDER_MINUTES,
          value:
            checkinReminderMinutes !== "" &&
            Number(checkinReminderMinutes) >= 0
              ? Number(checkinReminderMinutes)
              : 5,
        },
        {
          websiteCode: DataSetting.MSH_GROUP,
          name: DataSetting.FUEL_ALLOWANCE_ENABLED,
          value: checkedSwitchFuel,
        },
        {
          websiteCode: DataSetting.MSH_GROUP,
          name: DataSetting.CHECKIN_CORRECTION_HCNS_DIRECT,
          value: checkedSwitchCorrectionHcnsDirect,
        },
        {
          websiteCode: DataSetting.MSH_GROUP,
          name: DataSetting.LATE_CHECKIN_HCNS_DIRECT,
          value: checkedSwitchLateHcnsDirect,
        },
        {
          websiteCode: DataSetting.MSH_GROUP,
          name: DataSetting.LATE_CHECKIN_REQUEST_ENABLED,
          value: checkedSwitchLateRequest,
        },
        {
          websiteCode: DataSetting.MSH_GROUP,
          name: DataSetting.LATE_CHECKIN_STRICT_SUPPORT,
          value: checkedSwitchLateStrictSupport,
        },
        {
          websiteCode: DataSetting.MSH_GROUP,
          name: DataSetting.PUSH_NOTIFICATION_ENABLED,
          value: checkedSwitchPush,
        },
        {
          websiteCode: DataSetting.MSH_GROUP,
          name: DataSetting.FUEL_REQUEST_HCNS_DIRECT,
          value: checkedSwitchFuelHcnsDirect,
        },
        {
          websiteCode: DataSetting.MSH_GROUP,
          name: DataSetting.FUEL_ALLOWANCE_APPLY_DATE,
          value: fuelApplyDate || null,
        },
        {
          websiteCode: DataSetting.MSH_GROUP,
          name: DataSetting.FUEL_REQUEST_DEADLINE_DAY,
          // Trống / ngoài 1-31 => null (BE dùng mặc định ngày 10)
          value:
            fuelDeadlineDay !== "" &&
            Number.isInteger(Number(fuelDeadlineDay)) &&
            Number(fuelDeadlineDay) >= 1 &&
            Number(fuelDeadlineDay) <= 31
              ? Number(fuelDeadlineDay)
              : null,
        },
        ...fuelAmountValues.map((item) => ({
          websiteCode: DataSetting.MSH_GROUP,
          name: item.field.name,
          value: item.value,
        })),
        ...referralMilestoneValues.map((item) => ({
          websiteCode: DataSetting.MSH_GROUP,
          name: item.field.name,
          value: item.value,
        })),
      ];

      await settingCall.updateBulk(dataFilter);

      await settingCall.createAppVersion(optionsUpdateAppVersion);
      // await refetch();
      onCloseCheckinPlace();
      toast.success("Thêm thành công");
    } catch (error) {
      console.error("Error during check-in creation:", error);
      toast.error("Có lỗi xảy ra khi sửa");
    }

    toast.dismiss(toastCreate);
  };

  return (
    <Box
      w={{ base: "100%" }}
      backgroundColor="var(--color-backgroundmain)"
      p={{ base: "24px 16px 16px" }}
      minH={"98vh"}
    >
      <Text
        fontSize={{ base: "20px" }}
        fontWeight={600}
        p={"24px 0"}
        borderBottom={"1px solid var(--border-input-employee)"}
        mb={"24px"}
      >
        Cài đặt chung
      </Text>
      <Box>
        <SelectControl
          label="Địa chỉ chấm công mặc định"
          dataOption={checkinPlaces}
          placeholder="Chọn địa chỉ chấm công mặc định"
          selectedMain={watch("checkinPlaceId")}
          onChange={onchangeCheckinPlace}
          onFocus={() => handleFocus("checkinPlaceId")}
          onBlur={() => handleBlur("checkinPlaceId")}
          state={focusStates["checkinPlaceId"]}
          registerProps={register("checkinPlaceId")}
          errorMessage={errors.checkinPlaceId}
          mwidth="100%"
          isSearchable={true}
        />
        <Box mt={"24px"}></Box>
        <SelectControl
          label="Địa chỉ đăng ký chấm công ngoài mặc định"
          dataOption={checkinPlaces}
          placeholder="Chọn địa chỉ chấm công mặc định"
          selectedMain={watch("registerCheckinPlaceId")}
          onChange={onchangeRegisterCheckinPlace}
          onFocus={() => handleFocus("registerCheckinPlaceId")}
          onBlur={() => handleBlur("registerCheckinPlaceId")}
          state={focusStates["registerCheckinPlaceId"]}
          registerProps={register("registerCheckinPlaceId")}
          errorMessage={errors.registerCheckinPlaceId}
          mwidth="100%"
          isSearchable={true}
        />
        <Box mt={"24px"}></Box>
        <InputControl
          type="number"
          label="Số ngày tối đa khi xin nghỉ ngắn hạn"
          placeholder="Nhập số ngày tối đa khi xin nghỉ ngắn hạn"
          errors={errors.leaveRequestMoreShortTerm}
          register={register("leaveRequestMoreShortTerm")}
          onFocus={() => handleFocus("leaveRequestMoreShortTerm")}
          onBlur={() => handleBlur("leaveRequestMoreShortTerm")}
          state={focusStates["leaveRequestMoreShortTerm"]}
          mwidth="100%"
          background="var(--color-main)"
        />
        <Box mt={"24px"}></Box>
        <InputControl
          type="number"
          label="Số ngày tối đa khi xin nghỉ dài hạn"
          placeholder="Nhập số ngày tối đa khi xin nghỉ dài hạn"
          errors={errors.leaveRequestMoreLongTerm}
          register={register("leaveRequestMoreLongTerm")}
          onFocus={() => handleFocus("leaveRequestMoreLongTerm")}
          onBlur={() => handleBlur("leaveRequestMoreLongTerm")}
          state={focusStates["leaveRequestMoreLongTerm"]}
          mwidth="100%"
          background="var(--color-main)"
        />
        <Box mt={"24px"}></Box>
        <InputControl
          type="number"
          label="Bán kính cho phép của địa điểm chấm công"
          placeholder="Nhập bán kính cho phép của địa điểm chấm công"
          errors={errors.checkinRadius}
          register={register("checkinRadius")}
          onFocus={() => handleFocus("checkinRadius")}
          onBlur={() => handleBlur("checkinRadius")}
          state={focusStates["checkinRadius"]}
          mwidth="100%"
          background="var(--color-main)"
        />
        <Box mt={"24px"}></Box>
        <InputControl
          type="number"
          label="Giới hạn dung lượng file có thể upload (MB)"
          placeholder="Nhập giới hạn dung lượng file có thể upload (MB)"
          errors={errors.maxFileSize}
          register={register("maxFileSize")}
          onFocus={() => handleFocus("maxFileSize")}
          onBlur={() => handleBlur("maxFileSize")}
          state={focusStates["maxFileSize"]}
          mwidth="100%"
          background="var(--color-main)"
        />
        <Box mt={"24px"}></Box>
        {/*  */}
        <InputControl
          type="number"
          label="Mã nhân viên tự động tăng khi tạo tài khoản giới thiệu việc làm"
          placeholder="Nhập mã nhân viên tự động tăng"
          errors={errors.latestEmployeeId}
          register={register("latestEmployeeId")}
          onFocus={() => handleFocus("latestEmployeeId")}
          onBlur={() => handleBlur("latestEmployeeId")}
          state={focusStates["latestEmployeeId"]}
          mwidth="100%"
          background="var(--color-main)"
        />
        <Text
          color={"var(--color-option-employee-hover)"}
          fontSize={"12px"}
          mt={"6px"}
        >
          (Mã nhân viên sẽ hiển thị dạng CTV00"Mã NV tự động tăng")
        </Text>
        <Box mt={"24px"}></Box>
        <InputControl
          type="number"
          label="Số ngày hết hạn tạo tài khoản giới thiệu việc làm"
          placeholder="Nhập số ngày hết hạn tạo tài khoản giới thiệu việc làm"
          errors={errors.dateLatestEmployee}
          register={register("dateLatestEmployee")}
          onFocus={() => handleFocus("dateLatestEmployee")}
          onBlur={() => handleBlur("dateLatestEmployee")}
          state={focusStates["dateLatestEmployee"]}
          mwidth="100%"
          background="var(--color-main)"
        />
        <Box mt={"24px"}></Box>
        <FormTimeKeeping
          title={"TG bắt đầu"}
          place={"Đến giờ"}
          type="time"
          isIconPlace={false}
          isIconTime={true}
          length={"126px"}
          register={register("blockCheckinTimeStart")}
          errors={errors.blockCheckinTimeStart}
        />
        <Box mt={"24px"}></Box>
        <FormTimeKeeping
          title={"Giờ bắt đầu chiều"}
          place={"Đến giờ"}
          type="time"
          isIconPlace={false}
          isIconTime={true}
          length={"126px"}
          register={register("halfDayLeaveAfternoonStart")}
          errors={errors.halfDayLeaveAfternoonStart}
        />
        <Box mt={"24px"}></Box>
        <FormTimeKeeping
          title={"TG kết thúc"}
          place={"Đến giờ"}
          type="time"
          isIconPlace={false}
          isIconTime={true}
          length={"126px"}
          register={register("blockCheckinTime")}
          errors={errors.blockCheckinTime}
        />
        <Box mt={"24px"}></Box>
        <FormTimeKeeping
          title={"Hạn gửi đơn chấm công ngoài"}
          place={"Đến giờ"}
          type="time"
          isIconPlace={false}
          isIconTime={true}
          length={"126px"}
          register={register("registerCheckinDeadline")}
          errors={errors.registerCheckinDeadline}
        />
        <Text
          color={"var(--color-option-employee-hover)"}
          fontSize={"12px"}
          mt={"6px"}
        >
          Nhân viên chỉ gửi được đơn chấm công ngoài trong ngày trước giờ này
          (để trống = 10:00). HCNS tạo hộ trên web không bị chặn.
        </Text>
        <Box mt={"24px"}></Box>
        {/*  */}
        <InputControl
          type="number"
          label="Số ngày sẽ tự động xóa phản hồi"
          placeholder="Nhập số ngày sẽ tự động xóa phản hồi"
          errors={errors.DATE_DELETE_TRANSACTION_HISTORY}
          register={register("DATE_DELETE_TRANSACTION_HISTORY")}
          onFocus={() => handleFocus("DATE_DELETE_TRANSACTION_HISTORY")}
          onBlur={() => handleBlur("DATE_DELETE_TRANSACTION_HISTORY")}
          state={focusStates["DATE_DELETE_TRANSACTION_HISTORY"]}
          mwidth="100%"
          background="var(--color-main)"
        />

        <Text
          fontSize={{ base: "20px" }}
          fontWeight={600}
          p={"24px 0"}
          borderBottom={"1px solid var(--border-input-employee)"}
          mb={"24px"}
        >
          Thưởng giới thiệu
        </Text>

        <Text
          color={"var(--color-option-employee-hover)"}
          fontSize={"12px"}
          mb={"16px"}
        >
          Mốc 1 / Mốc 2 tính trong 1 tháng kể từ ngày vào làm của người được
          giới thiệu. Ngày đi làm là ngày có công (thứ 7 nửa công vẫn tính 1
          ngày); Mốc 2 đếm tổng số ngày, tính cả số ngày của Mốc 1. Nhân sự
          thường: người được giới thiệu nguồn cá nhân. HCNS: người giới thiệu
          thuộc phòng Hành chính nhân sự, người được giới thiệu nguồn công ty.
          Để trống: dùng mặc định. Thay đổi áp dụng ngay cho tất cả người được
          giới thiệu, kể cả các tháng trước.
        </Text>

        {REFERRAL_MILESTONE_FIELDS.map((milestone, index) => (
          <Box key={milestone.title} mt={index === 0 ? "0" : "24px"}>
            <Text fontSize={"16px"} fontWeight={600} mb={"12px"}>
              {milestone.title}
            </Text>

            <Flex gap={"16px"} flexWrap={"wrap"}>
              {milestone.fields.map((field) => (
                <Box key={field.name} flex={"1 1 240px"}>
                  <InputControl
                    type="number"
                    label={field.label}
                    placeholder={field.placeholder}
                    errors={errors[field.name]}
                    register={register(field.name)}
                    onFocus={() => handleFocus(field.name)}
                    onBlur={() => handleBlur(field.name)}
                    state={focusStates[field.name]}
                    mwidth="100%"
                    background="var(--color-main)"
                  />
                </Box>
              ))}
            </Flex>
          </Box>
        ))}

        <Text
          fontSize={{ base: "20px" }}
          fontWeight={600}
          p={"24px 0"}
          borderBottom={"1px solid var(--border-input-employee)"}
          mb={"24px"}
        >
          Cài đặt thiết bị
        </Text>

        <Box mt={"24px"}>
          <Text
            lineHeight={"15px"}
            m="0"
            fontSize={{ base: "12px" }}
            mb={"6px"}
            fontWeight={400}
            color={"var(--color-label-employee)"}
          >
            Bắt buộc đăng nhập đúng thiết bị (bind 1 NV / 1 thiết bị)
          </Text>

          <Switch
            {...register("deviceEnforceLogin")}
            isChecked={checkedSwitchDeviceEnforce}
            onChange={(e) => {
              const val = e.target.checked;
              setCheckedSwitchDeviceEnforce(val);
              setValue("deviceEnforceLogin", val);
            }}
          />

          <Text
            color={"var(--color-option-employee-hover)"}
            fontSize={"12px"}
            mt={"6px"}
          >
            Khi bật: NV chỉ đăng nhập được nếu mã thiết bị trùng với thiết bị đã
            bind. Lần đầu sẽ bind.
          </Text>
        </Box>

        <Box mt={"24px"} />

        <Box>
          <Text
            lineHeight={"15px"}
            m="0"
            fontSize={{ base: "12px" }}
            mb={"6px"}
            fontWeight={400}
            color={"var(--color-label-employee)"}
          >
            Whitelist bypass (deviceCode cách nhau dấu phẩy)
          </Text>

          <Textarea
            bg={"var(--color-main)"}
            borderRadius={"8px"}
            placeholder="VD: 123abc, 456def, ios-device-xyz"
            value={deviceWhitelist}
            onChange={(e) => {
              const val = e.target.value;
              setDeviceWhitelist(val);
              setValue("deviceWhitelistBypass", val);
            }}
          />

          <Text
            color={"var(--color-option-employee-hover)"}
            fontSize={"12px"}
            mt={"6px"}
          >
            Thiết bị trong whitelist sẽ được bypass kiểm tra (dùng cho dev/admin
            test).
          </Text>
        </Box>

        <Box mt={"24px"}>
          <Text
            lineHeight={"15px"}
            m="0"
            fontSize={{ base: "12px" }}
            mb={"6px"}
            fontWeight={400}
            color={"var(--color-label-employee)"}
          >
            Chấm công theo thiết bị và địa điểm đăng ký
          </Text>

          <Switch
            isChecked={checkedSwitchCheckinV2}
            onChange={(e) => setCheckedSwitchCheckinV2(e.target.checked)}
          />

          <Text
            color={"var(--color-option-employee-hover)"}
            fontSize={"12px"}
            mt={"6px"}
          >
            Nhân viên luôn đăng ký được 1 thiết bị + 1 địa điểm trên app mới.
            Tắt: chấm công như cũ. Bật: chỉ chấm công được trên thiết bị và tại
            địa điểm đã đăng ký (app cũ phải cập nhật).
          </Text>
        </Box>

        <Box mt={"16px"} maxW={"275px"}>
          <Text
            lineHeight={"15px"}
            m="0"
            fontSize={{ base: "12px" }}
            mb={"6px"}
            fontWeight={400}
            color={"var(--color-label-employee)"}
          >
            Ngày bắt đầu áp dụng
          </Text>

          <Input
            type="date"
            bg={"var(--color-main)"}
            borderRadius={"8px"}
            value={checkinV2ApplyDate}
            onChange={(e) => setCheckinV2ApplyDate(e.target.value)}
          />

          <Text
            color={"var(--color-option-employee-hover)"}
            fontSize={"12px"}
            mt={"6px"}
          >
            Để trống: áp dụng ngay khi bật. Nhập ngày: bật trước, từ ngày đó mới
            áp dụng (app hiện thông báo trước cho nhân viên).
          </Text>
        </Box>

        <Box mt={"16px"} maxW={"275px"}>
          <Text
            lineHeight={"15px"}
            m="0"
            fontSize={{ base: "12px" }}
            mb={"6px"}
            fontWeight={400}
            color={"var(--color-label-employee)"}
          >
            Nhắc chấm vào / chấm ra trước (phút)
          </Text>

          <Input
            type="number"
            min={0}
            bg={"var(--color-main)"}
            borderRadius={"8px"}
            value={checkinReminderMinutes}
            onChange={(e) => setCheckinReminderMinutes(e.target.value)}
          />

          <Text
            color={"var(--color-option-employee-hover)"}
            fontSize={"12px"}
            mt={"6px"}
          >
            Khi bật chấm công theo thiết bị và địa điểm: app gửi thông báo nhắc
            trước giờ vào và giờ ra (chỉ người chưa chấm, ngày được chấm công).
          </Text>
        </Box>

        <Box mt={"24px"}>
          <Text
            lineHeight={"15px"}
            m="0"
            fontSize={{ base: "12px" }}
            mb={"6px"}
            fontWeight={400}
            color={"var(--color-label-employee)"}
          >
            Áp dụng xăng xe (không đăng ký nhận xăng xe thì không cần chấm ra)
          </Text>

          <Switch
            isChecked={checkedSwitchFuel}
            onChange={(e) => setCheckedSwitchFuel(e.target.checked)}
          />

          <Text
            color={"var(--color-option-employee-hover)"}
            fontSize={"12px"}
            mt={"6px"}
          >
            Tắt: mọi nhân viên phải chấm ra mới đủ công như hiện tại. Bật: chỉ
            nhân viên đăng ký nhận xăng xe mới phải chấm ra, nhân viên không đăng ký thì
            công tính ngay lúc chấm vào. Riêng Khối hỗ trợ kinh doanh luôn phải
            chấm ra. Bật / tắt có tác dụng từ lần chấm vào tiếp theo.
          </Text>
        </Box>

        <Box mt={"16px"} maxW={"275px"}>
          <Text
            lineHeight={"15px"}
            m="0"
            fontSize={{ base: "12px" }}
            mb={"6px"}
            fontWeight={400}
            color={"var(--color-label-employee)"}
          >
            Ngày bắt đầu áp dụng xăng xe
          </Text>

          <Input
            type="date"
            bg={"var(--color-main)"}
            borderRadius={"8px"}
            value={fuelApplyDate}
            onChange={(e) => setFuelApplyDate(e.target.value)}
          />

          <Text
            color={"var(--color-option-employee-hover)"}
            fontSize={"12px"}
            mt={"6px"}
          >
            Để trống: áp dụng ngay khi bật. Nhập ngày: bật trước, từ ngày đó mới
            áp dụng.
          </Text>
        </Box>

        <Box mt={"16px"} maxW={"275px"}>
          <Text
            lineHeight={"15px"}
            m="0"
            fontSize={{ base: "12px" }}
            mb={"6px"}
            fontWeight={400}
            color={"var(--color-label-employee)"}
          >
            Hạn gửi đơn xăng xe (đến ngày)
          </Text>

          <Input
            type="number"
            min={1}
            max={31}
            placeholder="10"
            bg={"var(--color-main)"}
            borderRadius={"8px"}
            value={fuelDeadlineDay}
            onChange={(e) => setFuelDeadlineDay(e.target.value)}
          />

          <Text
            color={"var(--color-option-employee-hover)"}
            fontSize={"12px"}
            mt={"6px"}
          >
            Nhân viên gửi đơn đăng ký / bỏ đăng ký nhận xăng xe trên app từ ngày
            1 đến ngày này hàng tháng (1–31). Để trống: mặc định ngày 10.
          </Text>
        </Box>

        <Flex mt={"16px"} gap={"16px"} flexWrap={"wrap"}>
          {FUEL_LEVEL_AMOUNT_FIELDS.map((f) => (
            <Box key={f.name} w={"100%"} maxW={"275px"}>
              <Text
                lineHeight={"15px"}
                m="0"
                fontSize={{ base: "12px" }}
                mb={"6px"}
                fontWeight={400}
                color={"var(--color-label-employee)"}
              >
                Số tiền xăng xe mức {f.level} (VNĐ)
              </Text>

              <Input
                type="number"
                min={1}
                placeholder={f.placeholder}
                bg={"var(--color-main)"}
                borderRadius={"8px"}
                value={fuelLevelAmounts[f.level]}
                onChange={(e) =>
                  setFuelLevelAmounts((prev) => ({
                    ...prev,
                    [f.level]: e.target.value,
                  }))
                }
              />
            </Box>
          ))}
        </Flex>
        <Text
          color={"var(--color-option-employee-hover)"}
          fontSize={"12px"}
          mt={"6px"}
        >
          Nhân viên chọn mức khi gửi đơn đăng ký nhận xăng xe trên app. Đổi số
          tiền là đổi cho tất cả nhân viên đang ở mức đó. Để trống: mức 1 =
          3.000.000, mức 2 = 5.000.000, mức 3 = 7.000.000.
        </Text>

        <Box mt={"24px"}>
          <Text
            lineHeight={"15px"}
            m="0"
            fontSize={{ base: "12px" }}
            mb={"6px"}
            fontWeight={400}
            color={"var(--color-label-employee)"}
          >
            Đơn xăng xe: HCNS nhận thông báo và duyệt ngay
          </Text>

          <Switch
            isChecked={checkedSwitchFuelHcnsDirect}
            onChange={(e) => setCheckedSwitchFuelHcnsDirect(e.target.checked)}
          />

          <Text
            color={"var(--color-option-employee-hover)"}
            fontSize={"12px"}
            mt={"6px"}
          >
            Bật: HCNS nhận thông báo, nhìn thấy và duyệt được đơn ngay, không cần chờ quản lý
            duyệt bước 1; quản lý từ chối thì đơn vẫn chờ HCNS xem xét. Tắt: đơn phải được quản
            lý duyệt bước 1 trên app thì HCNS mới nhận thông báo và nhìn thấy đơn để duyệt; quản
            lý từ chối là đơn bị từ chối luôn. Nhân viên không có quản lý duyệt bước 1 thì đơn
            chuyển thẳng HCNS. Chỉ HCNS duyệt (bước 2) mới thay đổi xăng xe của nhân viên.
          </Text>
        </Box>

        <Box mt={"24px"}>
          <Text
            lineHeight={"15px"}
            m="0"
            fontSize={{ base: "12px" }}
            mb={"6px"}
            fontWeight={400}
            color={"var(--color-label-employee)"}
          >
            Đơn chỉnh sửa công: HCNS nhận thông báo và duyệt ngay
          </Text>

          <Switch
            isChecked={checkedSwitchCorrectionHcnsDirect}
            onChange={(e) => setCheckedSwitchCorrectionHcnsDirect(e.target.checked)}
          />

          <Text
            color={"var(--color-option-employee-hover)"}
            fontSize={"12px"}
            mt={"6px"}
          >
            Bật: HCNS nhận thông báo, nhìn thấy và duyệt được đơn ngay, không cần chờ quản lý
            duyệt bước 1. Tắt: đơn phải được quản lý duyệt bước 1 thì HCNS mới nhận thông báo và
            nhìn thấy đơn để duyệt; quản lý từ chối là đơn bị từ chối luôn. Nhân viên không có
            quản lý duyệt bước 1 thì đơn chuyển thẳng HCNS. Chỉ HCNS duyệt (bước 2) mới cập nhật
            công.
          </Text>
        </Box>

        <Box mt={"24px"}>
          <Text
            lineHeight={"15px"}
            m="0"
            fontSize={{ base: "12px" }}
            mb={"6px"}
            fontWeight={400}
            color={"var(--color-label-employee)"}
          >
            Áp dụng đơn xin đi muộn (thay danh sách đi muộn theo điểm chấm công)
          </Text>

          <Switch
            isChecked={checkedSwitchLateRequest}
            onChange={(e) => setCheckedSwitchLateRequest(e.target.checked)}
          />

          <Text
            color={"var(--color-option-employee-hover)"}
            fontSize={"12px"}
            mt={"6px"}
          >
            Bật: nhân viên gửi đơn xin đi muộn trên app (quản lý duyệt bước 1, HCNS duyệt bước 2 ở
            Quản lý chấm công - tab Đơn xin đi muộn). Lúc chấm công chỉ xét nhân viên có đơn đã duyệt
            còn hiệu lực, không xét điểm chấm công: chấm vào trước (TG đúng giờ + số phút được đi
            muộn, vd 8:30 + 30 phút = 9:00) được đủ công (thứ 7: 0.5 công), từ mốc đó trở đi là 0
            công; chấm buổi chiều vẫn 0.5 công. Quy tắc này áp cho khối kinh doanh (khối hỗ trợ
            kinh doanh theo cài đặt bên dưới), chỉ cho các lần chấm sau khi bật (không tính lại ngày
            đã qua). Tắt: như cũ - đi
            muộn theo danh sách nhân viên của từng điểm chấm công (cộng số phút vào cả TG đúng giờ
            và TG muộn giờ), app ẩn Đơn xin đi muộn.
          </Text>
        </Box>

        <Box mt={"24px"}>
          <Text
            lineHeight={"15px"}
            m="0"
            fontSize={{ base: "12px" }}
            mb={"6px"}
            fontWeight={400}
            color={"var(--color-label-employee)"}
          >
            Đơn xin đi muộn: áp dụng quy tắc mới cho khối hỗ trợ kinh doanh
          </Text>

          <Switch
            isChecked={checkedSwitchLateStrictSupport}
            onChange={(e) => setCheckedSwitchLateStrictSupport(e.target.checked)}
          />

          <Text
            color={"var(--color-option-employee-hover)"}
            fontSize={"12px"}
            mt={"6px"}
          >
            Chỉ có tác dụng khi đã bật "Áp dụng đơn xin đi muộn". Bật: nhân viên hỗ trợ kinh doanh có
            đơn đi muộn cũng theo quy tắc mới (chấm từ TG đúng giờ + số phút được đi muộn trở đi là 0
            công). Tắt: nhân viên hỗ trợ kinh doanh vẫn tính như cũ - chấm trong khoảng TG đúng giờ
            đến TG muộn giờ (đã cộng số phút được đi muộn) vẫn đủ công nhưng bị phạt, sau TG muộn giờ
            được 0.5 công.
          </Text>
        </Box>

        <Box mt={"24px"}>
          <Text
            lineHeight={"15px"}
            m="0"
            fontSize={{ base: "12px" }}
            mb={"6px"}
            fontWeight={400}
            color={"var(--color-label-employee)"}
          >
            Đơn xin đi muộn: HCNS nhận thông báo và duyệt ngay
          </Text>

          <Switch
            isChecked={checkedSwitchLateHcnsDirect}
            onChange={(e) => setCheckedSwitchLateHcnsDirect(e.target.checked)}
          />

          <Text
            color={"var(--color-option-employee-hover)"}
            fontSize={"12px"}
            mt={"6px"}
          >
            Bật: HCNS nhận thông báo, nhìn thấy và duyệt được đơn ngay, không cần chờ quản lý
            duyệt bước 1; quản lý từ chối thì đơn vẫn chờ HCNS xem xét. Tắt: đơn phải được quản
            lý duyệt bước 1 trên app thì HCNS mới nhận thông báo và nhìn thấy đơn để duyệt; quản
            lý từ chối là đơn bị từ chối luôn. Nhân viên không có quản lý duyệt bước 1 thì đơn
            chuyển thẳng HCNS. Chỉ HCNS duyệt (bước 2) đơn mới có hiệu lực.
          </Text>
        </Box>

        <Box mt={"24px"}>
          <Text
            lineHeight={"15px"}
            m="0"
            fontSize={{ base: "12px" }}
            mb={"6px"}
            fontWeight={400}
            color={"var(--color-label-employee)"}
          >
            Gửi thông báo đẩy (app và web)
          </Text>

          <Switch
            isChecked={checkedSwitchPush}
            onChange={(e) => setCheckedSwitchPush(e.target.checked)}
          />

          <Text
            color={"var(--color-option-employee-hover)"}
            fontSize={"12px"}
            mt={"6px"}
          >
            Tắt: hệ thống không gửi bất kỳ thông báo đẩy nào ra app / trình duyệt.
          </Text>
        </Box>

        <Text
          fontSize={{ base: "20px" }}
          fontWeight={600}
          p={"24px 0"}
          borderBottom={"1px solid var(--border-input-employee)"}
          mb={"24px"}
        >
          Mật khẩu hỗ trợ đăng nhập
        </Text>

        <Box>
          <Text
            color={"var(--color-option-employee-hover)"}
            fontSize={"12px"}
            mb={"16px"}
          >
            {masterPasswordStatus?.isSet
              ? `Đang bật. Cập nhật lần cuối: ${
                  masterPasswordStatus?.updatedAt || "-"
                }${
                  masterPasswordStatus?.updatedBy?.fullName
                    ? ` - ${masterPasswordStatus.updatedBy.fullName}`
                    : ""
                }.`
              : "Chưa thiết lập."}
            {" Vì lý do bảo mật, hệ thống không hiển thị lại mật khẩu đã lưu."}
          </Text>

          <InputControl
            type="password"
            label="Mật khẩu hỗ trợ"
            placeholder="Chưa thiết lập mật khẩu hỗ trợ"
            value={masterPasswordStatus?.isSet ? "**********" : ""}
            disabled
            readonly
            mwidth="100%"
            background="var(--color-main)"
          />

          <Flex mt={"16px"} gap={"12px"}>
            <Button
              type="button"
              fontSize={"15px"}
              fontWeight={600}
              color={"var(--color-main)"}
              borderRadius={"8px"}
              bg={"var(--color-option-employee-hover)"}
              _hover={{
                filter: "brightness(90%)",
              }}
              onClick={() =>
                openMasterPasswordPopup(MASTER_PASSWORD_MODE.UPDATE)
              }
            >
              {masterPasswordStatus?.isSet ? "Đổi mật khẩu" : "Đặt mật khẩu"}
            </Button>

            {!!masterPasswordStatus?.isSet && (
              <Button
                type="button"
                variant={"outline"}
                fontSize={"15px"}
                fontWeight={600}
                borderRadius={"8px"}
                onClick={() =>
                  openMasterPasswordPopup(MASTER_PASSWORD_MODE.CLEAR)
                }
              >
                Xoá mật khẩu
              </Button>
            )}
          </Flex>
        </Box>

        <Text
          fontSize={{ base: "20px" }}
          fontWeight={600}
          p={"24px 0"}
          borderBottom={"1px solid var(--border-input-employee)"}
          mb={"24px"}
        >
          Cài đặt SMTP
        </Text>
        <Box mt={"24px"}>
          <Text
            lineHeight={"15px"}
            m="0"
            fontSize={{ base: "12px" }}
            mb={"6px"}
            fontWeight={400}
            color={"var(--color-label-employee)"}
          >
            Thông báo email
          </Text>
          <Switch
            {...register("isSmtp")}
            isChecked={checkedSwitch}
            onChange={(e) => setCheckedSwitch(e.target.checked)}
          />
        </Box>
        <Box mt={"24px"}></Box>
        <InputControl
          label="SMTP Email"
          placeholder="Nhập SMTP email"
          errors={errors.emailUser}
          register={register("emailUser")}
          onFocus={() => handleFocus("emailUser")}
          onBlur={() => handleBlur("emailUser")}
          state={focusStates["emailUser"]}
          mwidth="100%"
          background="var(--color-main)"
        />
        <Box mt={"24px"}></Box>
        <InputControl
          label="SMTP Password"
          placeholder="Nhập SMTP password"
          errors={errors.emailPassword}
          register={register("emailPassword")}
          onFocus={() => handleFocus("emailPassword")}
          onBlur={() => handleBlur("emailPassword")}
          state={focusStates["emailPassword"]}
          mwidth="100%"
          background="var(--color-main)"
        />

        {/*  */}
        <Text
          fontSize={{ base: "20px" }}
          fontWeight={600}
          p={"24px 0"}
          borderBottom={"1px solid var(--border-input-employee)"}
          mb={"24px"}
        >
          Cập nhật version
        </Text>
        <Box mt={"24px"}>
          <Text
            lineHeight={"15px"}
            m="0"
            fontSize={{ base: "12px" }}
            mb={"6px"}
            fontWeight={400}
            color={"var(--color-label-employee)"}
          >
            Thông báo phiên bản mới
          </Text>
          <Switch
            {...register("isForce")}
            isChecked={checkedSwitchNotification}
            onChange={(e) => setCheckedSwitchNotification(e.target.checked)}
          />
        </Box>
        <Box mt={"24px"}></Box>
        <InputControl
          label="Phiên bản"
          placeholder="Nhập phiên bản"
          errors={errors.versionName}
          register={register("versionName")}
          onFocus={() => handleFocus("versionName")}
          onBlur={() => handleBlur("versionName")}
          state={focusStates["versionName"]}
          mwidth="100%"
          background="var(--color-main)"
        />
        <Box mt={"24px"}></Box>
        <InputControl
          label="Link tải cho android"
          placeholder="Nhập đường dẫn tải xuống"
          errors={errors.urlAndroid}
          register={register("urlAndroid")}
          onFocus={() => handleFocus("urlAndroid")}
          onBlur={() => handleBlur("urlAndroid")}
          state={focusStates["urlAndroid"]}
          mwidth="100%"
          background="var(--color-main)"
        />
        <Box mt={"24px"}></Box>
        <InputControl
          label="Link tải cho ios"
          placeholder="Nhập đường dẫn tải xuống"
          errors={errors.urlIos}
          register={register("urlIos")}
          onFocus={() => handleFocus("urlIos")}
          onBlur={() => handleBlur("urlIos")}
          state={focusStates["urlIos"]}
          mwidth="100%"
          background="var(--color-main)"
        />
      </Box>

      <Flex p={"24px 0"} gap={"16px"} justifyContent={"flex-start"}>
        <Button
          type="submit"
          w={"112px"}
          fontSize={"15px"}
          fontWeight={600}
          color={"var(--color-main)"}
          borderRadius={"8px"}
          bg={"var(--color-option-employee-hover)"}
          _hover={{
            filter: "brightness(90%)",
          }}
          onClick={onCloseCheckinPlaceData}
        >
          Lưu
        </Button>
      </Flex>

      {/* key ép popup dựng lại khi đổi chế độ để form luôn sạch và validate
          đúng theo chế độ đang mở */}
      <PopupMasterPassword
        key={`${masterPasswordMode}-${masterPasswordStatus?.isSet}`}
        isOpen={isOpenMasterPassword}
        onClose={onCloseMasterPassword}
        isSet={Boolean(masterPasswordStatus?.isSet)}
        mode={masterPasswordMode}
        minLength={masterPasswordStatus?.minLength}
        isLoading={isSavingMasterPassword}
        onSubmit={submitHandlerMasterPassword}
      />

      <CheckinPlaceDialog
        isOpen={isOpenCheckinPlace}
        onClose={onCloseCheckinPlace}
        title="Thay đổi cài đặc mặc định"
        description={
          <Flex display={"inline"}>
            "Bạn có chắc chắn lưu cài đặt này không?"
          </Flex>
        }
        action={() => submitHandlerCheckinPlace()}
        textDelete={"Lưu thay đổi"}
      />
    </Box>
  );
}

export default SettingManagement;
